<template>
    <div>
        <ul v-if="authd_links_toggle" id="nav-mobile" class="right hide-on-med-and-down">
            
            <span v-show="authd_links_toggle">
                <div @click="toggle_shopping_cart()" id="popup-shopping-cart-button" class="notification-button">
                    <font-awesome-icon class="" size="lg" :icon="['fas', 'shopping-cart']"/>
                    <span >{{this.$store.getters.shopping_cart_count}}</span>
                </div>
                
                <div  id="popup-shopping-cart-container" class="popup-shopping-cart-container hidden">
                    <div class="popup-shopping-cart-opening">

                        

                    </div>
                    
                    <div class="popup-shopping-cart">
                        <popup_shopping_cart />
                        
                    </div>
                    <div class="review-container">
                        <button class="btn blue darken-2"><router-link class="waves-effect" to="/shopping_cart">Review Order <font-awesome-icon class="" size="lg" :icon="['fas', 'check']"/></router-link></button>
                    </div>
                    
                </div>
                <div class="notification-button">
                    
                    <font-awesome-icon class="" size="lg" :icon="['fas', 'bell']"/>
                </div>
            </span>
        </ul>
    </div>
</template>
<script>
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

import { store } from '../storage/vuex-store.js'
import { mapGetters } from 'vuex'
import { mapMutations } from 'vuex'
import { mapActions } from 'vuex'


import popup_shopping_cart from '@/components/popup_shopping_cart'

const state = {
	auth_links:{
		show: false
    },
    authd_links:{
        show: false
    },
    products_in_shopping_cart: {}

}

const mutations = {
	show_auth_links(state){
		state.auth_links.show = true
	},
	hide_auth_links(state){
		state.auth_links.show = false
		
    },
    show_authd_links(state){
		state.authd_links.show = true
	},
	hide_authd_links(state){
		state.authd_links.show = false
		
	}
}

const storage = new Vuex.Store({
	state,
	mutations
})


export default {
    name: 'navbar_menu',
    data: function(){
        return{
            
        }
    },
    methods:{
        ...mapGetters([
            'shopping_cart_count'
        ]),
        ...mapMutations([
            'set_shopping_cart_count'
		]),
		...mapActions([
			'set_shopping_cart_count'
		]),

        toggle_shopping_cart(){

            if(jQuery('#popup-shopping-cart-container').hasClass('hidden')){
                console.log('opening cart')
                jQuery('#popup-shopping-cart-container').removeClass('hidden')
                jQuery('#popup-shopping-cart-container').addClass('animated fadeIn')
            }else{
                console.log('closing cart')
                jQuery('#popup-shopping-cart-container').addClass('hidden')
            }

            

        }

    },
    components:{
        popup_shopping_cart
        
    },
    computed: {
        
        auth_links_toggle(){
			return storage.state.auth_links.show
        },
        authd_links_toggle(){
            return storage.state.authd_links.show
        },
        get_products_in_shopping_cart(){
            return storage.state.products_in_shopping_cart
        },
    },
    watch:{
        $route: function(){
			if(this.$route.path === '/login' || this.$route.path === '/logout' || this.$route.path === '/register'){
                storage.commit('show_auth_links')
                storage.commit('hide_authd_links')
			}else{
                storage.commit('hide_auth_links')
                storage.commit('show_authd_links')
			}
		}, 
		deep: true,
		immediate: true
    },
    created: function(){
        if(this.$route.path === '/login' || this.$route.path === '/logout' || this.$route.path === '/register'){
                storage.commit('show_auth_links')
                storage.commit('hide_authd_links')
			}else{
                storage.commit('hide_auth_links')
                storage.commit('show_authd_links')
			}
    },
    mounted: function(){
        store.dispatch('set_shopping_cart_count')

        jQuery('html').click(function() {
            if(jQuery('#popup-shopping-cart-container').hasClass('hidden')){

            }else{
                jQuery('#popup-shopping-cart-container').addClass('hidden')
            }
        });

        jQuery('#popup-shopping-cart-container').click(function(event){
            event.stopPropagation();
        });

        jQuery('#popup-shopping-cart-button').click(function(event){
            event.stopPropagation();
        });
    }
    
}

</script>



// WEBPACK FOOTER //
// src/components/navbar_menu.vue